"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transitionConfigs = exports.Transition = exports.slideContent = exports.notifyConfig = exports.popConfig = exports.slideDownConfig = exports.slideRightConfig = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TransitionGroup = _interopRequireDefault(require("react-transition-group/TransitionGroup"));

var _CSSTransition = _interopRequireDefault(require("react-transition-group/CSSTransition"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var slideRightConfig = {
  name: 'slideright',
  time: 300
};
exports.slideRightConfig = slideRightConfig;
var slideDownConfig = {
  name: 'slidedown',
  time: 300
};
exports.slideDownConfig = slideDownConfig;
var popConfig = {
  name: 'pop',
  time: 300
};
exports.popConfig = popConfig;
var notifyConfig = {
  name: 'notify',
  time: 300
};
exports.notifyConfig = notifyConfig;
var slideContent = {
  name: 'slide',
  time: 500
};
exports.slideContent = slideContent;

var Transition = function Transition(_ref) {
  var config = _ref.config,
      children = _ref.children;
  var name = config.name,
      time = config.time;
  return _react.default.createElement(_TransitionGroup.default, null, _react.default.createElement(_CSSTransition.default, {
    classNames: name,
    appear: false,
    enter: true,
    exit: false,
    timeout: time
  }, _react.default.createElement(_react.Fragment, null, children)));
};

exports.Transition = Transition;
Transition.defaultProps = {
  config: slideContent
};
Transition.propTypes = {
  children: _propTypes.default.node.isRequired,
  config: _propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    time: _propTypes.default.number.isRequired
  })
};
var transitionConfigs = {
  popConfig: popConfig,
  notifyConfig: notifyConfig,
  slideContent: slideContent,
  slideDownConfig: slideDownConfig,
  slideRightConfig: slideRightConfig
};
exports.transitionConfigs = transitionConfigs;